import React from 'react';
import classNames from 'classnames';
import { PanelRightClose, PanelLeftClose } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/Button/Button';
import { useLayoutStore } from 'stores/useLayoutStore';

export const CollapseButton = ({ className }) => {
  const { t } = useTranslation();
  const { sidebarCollapse: isCollapsed, setSidebarCollapse } = useLayoutStore();

  const handleClick = () => {
    setSidebarCollapse(!isCollapsed);
  }

  return (
    <Button
      type="button"
      aria-label={t(isCollapsed ? 'navBar.openNavigation' : 'navBar.closeNavigation')}
      aria-expanded={!isCollapsed}
      aria-controls="app-navigation"
      className={
        classNames(
          'min-h-[44px] min-w-[44px] flex-none transition-all text-ui-2 hover:text-ui',
          className,
        )
      }
      onClick={handleClick}
    >
      {isCollapsed ? <PanelRightClose size={20} /> : <PanelLeftClose size={20} />}
    </Button>
  );
}
